import type { AiBusinessCenterModule } from '../types'

/** OA办公独立应用配置。 */
export const oaModule: AiBusinessCenterModule = {
  key: 'oa',
  label: 'OA办公管理系统',
  desc: '公文/流程/会议/会议室/用车/用品/公告/文档协作/日程/邮件/印章/考勤/假期/个人工作台',
  path: '/oa',
  homePath: '/oa/doc-collab/document',
  icon: 'ep:office-building',
  color: '#3b82f6'
}
